import React, { useEffect, useState } from 'react'
import { Form, Input, message } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import * as API from '../../../../api'
import * as UTILS from '../../../../utils'
import './index.less'
export interface RegisterFormProps {
	goLogin?: () => void;
}

const RegisterForm: React.FC<RegisterFormProps> = ({
	goLogin,
}) => {
	const [submitEnabled, setSubmitEnabled] = useState<boolean>(false)
	const [loading, setLoading] = useState<boolean>(false)

	const [getVercodeEnabled, setGetVerCodeEnabled] = useState<boolean>(false)
	const [count, setCount] = useState<number>(60)
	const [isSend, setIsSend] = useState<boolean>(false) // 是否已经发送验证码

	const [form] = Form.useForm()

	const goToLogin = () => {
		goLogin && goLogin()
	}

	const formValidate = async () => {
		if (!form.isFieldsTouched()) return
		setTimeout(() => {
			const objValidate = UTILS.objValidate(form.getFieldsValue())
			const errors = form.getFieldsError().filter(item => item.errors.length > 0)
			const allTouched = form.isFieldsTouched(['username', 'userPhone', 'password', 'confirmPassword'], true)
			setGetVerCodeEnabled(allTouched && errors.length === 0)
			setSubmitEnabled(objValidate && errors.length === 0)
		}, 0)
	}

	const getVerCode = async () => {
		const userPhone = form.getFieldValue('userPhone')
		try {
			setIsSend(true)
			const { code, msg } = await API.Login.sendCode({ userPhone })
			if (code === 0 || code === 10030) {
				message.info(msg || '验证码已发送')
			} else {
				message.error(msg)
				setIsSend(false)
			}
		} catch (error) {
			message.error('验证码发送失败')
			setIsSend(false)
		}
	}

	useEffect(() => {
		let timer
		if (isSend && count) {
			timer = setInterval(() => {
				setCount(n => {
					if (n === 0) {
						setIsSend(false)
						clearInterval(timer)
					}
					return n - 1
				})
			}, 1000)
		} else {
			setCount(60)
		}
		return () => clearInterval(timer)
	}, [isSend])

	const onSubmit = async () => {
		if (!submitEnabled) return
		const fieldsValue = form.getFieldsValue()
		try {
			setLoading(true)
			// 不存在该手机号
			const { code, msg: signUpMsg } = await API.Login.signUp(fieldsValue)
			setLoading(false)
			if (code === 0) {
				message.success('注册成功')
				goToLogin()
			} else {
				setLoading(false)
				message.error(signUpMsg)
			}
		} catch (error) {
			setLoading(false)
			message.error('注册失败')
		}
	}

	return (
		<div className="register-form">
			<h5>账号注册</h5>
			<Form
				form={form}
				onValuesChange={() => formValidate()}
			>
				<Form.Item name="username" validateTrigger="onChange" rules={[
					{ required: true, message: '请输入用户名' },
					{ validator: (rule, value) => UTILS.getByteLength(value) > 6 ? Promise.reject('用户名最多6个字节') : Promise.resolve() }
				]}>
					<Input placeholder="请输入用户名，最多6个字符" autoComplete="off" />
				</Form.Item>

				<Form.Item name="userPhone" validateTrigger="onChange" rules={[
					{ required: true, message: '请输入手机号' },
					{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' },
				]}>
					<Input placeholder="请输入手机号" autoComplete="off" />
				</Form.Item>

				<Form.Item name="password" validateTrigger="onChange" rules={[
					{ required: true, message: '请输入登录密码' },
					{ min: 8, message: '请输入至少8位字符' },
				]}>
					<Input type="password" placeholder="请设置登录密码，至少8位字符" />
				</Form.Item>

				<Form.Item name="confirmPassword" dependencies={['password']} validateTrigger="onChange" rules={[
					{ required: true, message: '请再次输入密码' },
					({ getFieldValue }) => ({
						validator(rule, value) {
							if (!value || getFieldValue('password') === value) {
								return Promise.resolve()
							}
							return Promise.reject('两次输入的密码不一致')
						},
					}),
				]}>
					<Input type="password" placeholder="请再次输入密码" />
				</Form.Item>

				<Form.Item name="checkCode">
					<Input placeholder="请输入验证码" autoComplete="off"
						suffix={
							getVercodeEnabled
								? (isSend
									? <div className="vercode-btn waiting">重新获取{count}s</div>
									: <div className="vercode-btn active" onClick={getVerCode}>获取验证码</div>
								)
								: <div className="vercode-btn">获取验证码</div>
						}
					/>
				</Form.Item>
			</Form>

			{loading
				? <div className="submit-button active" style={{ boxShadow: 'inset 0 0 1000px rgba(255, 255, 255, 0.3)' }}><LoadingOutlined />注册</div>
				: <div className={submitEnabled ? 'submit-button active' : 'submit-button'} onClick={onSubmit}>注册</div>
			}

			<div style={{ textAlign: 'center' }}>
				<span className="link" onClick={goToLogin}>已有账号，返回登录</span>
			</div>
		</div>
	)
}

export default RegisterForm
